import { CSSProperties } from 'react';

export let windowScale = 1;
const min_size = 800;
const max_scale = 1.5;

export const scaleWindow = () => {
  // if (EventCenter.isPC() && !isNativeDevice()) {
  const wh = window.screen.height;
  // const wh = window.innerHeight;
  if (wh < min_size) {
    const ih = window.innerHeight;
    const dp = Math.min(min_size / ih, max_scale);
    (document.body.style as CSSProperties).zoom = 1 / dp;
    const v = window.getComputedStyle(document.body).getPropertyValue('zoom')?.toString();
    if (v){
      windowScale = dp;
    }
  }
};

export const getZoom = () => {
  try {
    const v = window.getComputedStyle(document.body).getPropertyValue('zoom')?.toString();
    if (v) {
      return parseFloat(v);
    }
    return windowScale;
  } catch (e) {
    return windowScale;
  }
};

export const scaleDom = (selector: string) => {
  const wh = window.screen.height;
  const root = document.querySelector(selector) as HTMLDivElement;
  if (wh < min_size && root) {
    const ih = window.innerHeight;
    const dp = Math.min(min_size / ih, max_scale);
    const size = dp * 100 + '%';
    const scale = 1 / dp;
    root.style.transform = `scale(${scale})`;
    root.style.transformOrigin = '0 0';
    root.style.width = size;
    root.style.height = size;
  }
  
};

let isTransformAffectedCache: boolean | null = null;

export const isTransformAffectedByZoom = (): boolean => {
  if (isTransformAffectedCache !== null) {
    return isTransformAffectedCache; // 返回缓存结果
  }

  // 执行测试逻辑
  const testElement = document.createElement('div');
  const testElementChild = document.createElement('div');
  testElement.appendChild(testElementChild);
  testElement.style.position = 'fixed';
  testElement.style.top = '0';
  testElement.style.left = '0';
  testElement.style.visibility = 'hidden';
  testElementChild.style.transform = 'translate(30px, 30px)';
  (testElement.style as any).zoom = '1';

  document.body.appendChild(testElement);

  const initialRect = testElementChild.getBoundingClientRect();
  console.log('int', initialRect.left);
  (testElement.style as any).zoom = '2';
  const zoomedRect = testElementChild.getBoundingClientRect();
  console.log('s', zoomedRect.left);

  document.body.removeChild(testElement);

  isTransformAffectedCache = initialRect.left !== zoomedRect.left || initialRect.top !== zoomedRect.top;
  return isTransformAffectedCache;
};

isTransformAffectedByZoom();